/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Organizerfollowflyerheadline3Inputs */

const en_organizerfollowflyerheadline3 = /** @type {(inputs: Organizerfollowflyerheadline3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Follow ${i?.name} on Pulsify`)
};

const de_organizerfollowflyerheadline3 = /** @type {(inputs: Organizerfollowflyerheadline3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Folge ${i?.name} auf Pulsify`)
};

/**
* | output |
* | --- |
* | "Follow {name} on Pulsify" |
*
* @param {Organizerfollowflyerheadline3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizerfollowflyerheadline3 = /** @type {((inputs: Organizerfollowflyerheadline3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizerfollowflyerheadline3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizerfollowflyerheadline3(inputs)
	return de_organizerfollowflyerheadline3(inputs)
});
export { organizerfollowflyerheadline3 as "organizerFollowFlyerHeadline" }